import { httpService } from "../http"
import { QuestionType, RankingListType, SibmitAnswer, StatusType } from "./answer";

const REACT_APP_GO_MICRO = process.env.REACT_APP_GO_MICRO;
// 获取题目列表
export const getBeginList = async (param: { questionNum: number }): Promise<{list :QuestionType[]}> => {
  return httpService.post(`/mp2c-micro/quiz/v1/begin`, param, {baseURL:REACT_APP_GO_MICRO});
}
// 提交答案
export const submitBegin = async (param: SibmitAnswer): Promise<{right: number, ans:number[], assist:number}> => {
  return httpService.post(`/mp2c-micro/quiz/v1/submitOne`, param, {baseURL:REACT_APP_GO_MICRO});
}
// 获取题目
export const getQuestion = async (param: {questionId: string}): Promise<any> => {
  return httpService.get(`/mp2c-micro/quiz/v1/getQuestion`, param, {baseURL:REACT_APP_GO_MICRO});
}

interface  FriendsSibmitAnswer extends Pick<SibmitAnswer, "option"> {
  questionId: number;
  inviter: number;
}

// 好友提交答案
export const postFriendSubmit = async (param: FriendsSibmitAnswer): Promise<{status: number, right: 1|0,ans:number[]}> => {
  return httpService.post(`/mp2c-micro/quiz/v1/invitedByAnswer`, param, {baseURL:REACT_APP_GO_MICRO});
}
// 获取好友答题状态
export const postInvitedStatus = async (param: {questionId: number}): Promise<{status: number}> => {
  return httpService.get(`/mp2c-micro/quiz/v1/invitedStatus`, param, {baseURL:REACT_APP_GO_MICRO});
}

// 排行榜
export const getWeekRankingList = async (): Promise<{member:RankingListType, rankingList:RankingListType[]}> => {
  return httpService.get(`/mp2c-micro/quiz/v1/rankingList`, {topN: 20}, {baseURL:REACT_APP_GO_MICRO});
}
//:周榜公示获奖
export const getPublicity = async (): Promise<{rankingList:RankingListType[]}> => {
  return httpService.get(`/mp2c-micro/quiz/v1/weekRankingList`, {topN: 20}, {baseURL:REACT_APP_GO_MICRO});
}

/**
 * 获取结算页数据
 * @returns 
 */
export const getScore = async (): Promise<StatusType> => {
  return httpService.get(`/mp2c-micro/quiz/v1/getScore`, {}, {baseURL:REACT_APP_GO_MICRO});
}
/**
 * 放弃答题
 * @returns 
 */
export const postGiveup = async (): Promise<any> => {
  return httpService.post(`/mp2c-micro/quiz/v1/giveup`, {}, {baseURL:REACT_APP_GO_MICRO});
}


/**
 * 检测邀请答题状态
 * @returns 
 */
interface CheckInvitedStatus {
  questionId: string;
  inviter: string;
} 
export const getShareCheck = async (param:CheckInvitedStatus): Promise<{status: 1|2|3}> => {
  return httpService.get(`/mp2c-micro/quiz/v1/share/check`, param, {baseURL:REACT_APP_GO_MICRO});
}
